import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ReportEntity } from './report.entity';

@Index('ux_query', ['alias'], { unique: true })
@Entity('_query_store')
export class QueryStoreEntity extends BaseEntity {
	@Column('varchar', { name: '_alias', unique: true, length: 100 })
	public alias!: string;

	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('longtext', { name: '_definition' })
	public definition!: string;

	@Column('tinyint', {
		name: '_internal',
		unsigned: true,
		default: () => "'0'",
	})
	public internal!: number;

	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('varchar', { name: '_module', nullable: true, length: 32 })
	public module!: string | null;

	@Column('varchar', { name: '_icon', nullable: true, length: 255 })
	public icon!: string | null;

	@OneToMany(() => ReportEntity, (report) => report.fkQueryStore, {})
	public reports!: Array<ReportEntity>;
}
